export default __webpack_public_path__ + "static/media/product-screw-collector.5bba0c7c.svg";